// extracted by mini-css-extract-plugin
export var indeterminate = "_47-5";
export var md = "_47-4";
export var semantic = "_47-6";
export var sm = "_47-3";
export var text = "_47-7";
export var toggleInput = "_47-0";
export var toggleSwitch = "_47-1";
export var xs = "_47-2";